import { connect } from 'react-redux';
import LandingPage from '../components/pages/LandingPage';
import {loginByGoogle} from '../actions/auth';

const mapStateToProps = (_,ownProps) => {
	return {
		...ownProps,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onClickLogin : ()=>{
			dispatch(loginByGoogle());
		},
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);